import React, { useEffect, useState } from 'react';

import accessLocalStorage from '../../../services/accessLocalStorage';
import { getCsatSurveys, getCsatBindings, setCsatBinding } from '../../../services/csatApi';
import { hasFeature } from '../../../services/permissions';

export const QUEUE_CSAT_MESSAGES = {
  label: 'Pesquisa de satisfação',
  none: 'Nenhuma',
  apply: 'Aplicar pesquisa',
  applied: 'Pesquisa da fila atualizada.',
  reloadPending: 'Configuração salva, mas o Asterisk não recarregou. Salve novamente em instantes.',
  failed: 'Não foi possível aplicar a pesquisa à fila.',
};

export const canManageQueueCsat = (hasFeatureFn) =>
  !!hasFeatureFn('config.filas', 'edit') && !!hasFeatureFn('config.chamadas.csat', 'view');

const sessionTenant = () => {
  const session = accessLocalStorage.getUserLocalStorage();
  return session && session.user ? session.user.idtenant : null;
};

function QueueCsatSelector({ queueName }) {
  const [surveys, setSurveys] = useState([]);
  const [selected, setSelected] = useState('');
  const [current, setCurrent] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let active = true;
    const tenant = sessionTenant();
    Promise.all([getCsatSurveys(tenant), getCsatBindings(tenant)]).then(([surveyResult, bindingResult]) => {
      if (!active) return;
      const list = surveyResult.success ? surveyResult.data : [];
      const binding = bindingResult.success ? bindingResult.data.find((item) => item.queueName === queueName) : null;
      const boundId = binding ? String(binding.surveyId) : '';
      setSurveys(list.filter((survey) => survey.active || String(survey.id) === boundId));
      setSelected(boundId);
      setCurrent(boundId);
    });
    return () => { active = false; };
  }, [queueName]);

  const apply = async () => {
    if (saving || selected === current) return;
    setSaving(true);
    setMessage(null);
    const result = await setCsatBinding({ tenant: sessionTenant(), queueName, surveyId: selected ? Number(selected) : null });
    setSaving(false);
    if (!result.success) {
      setMessage({ type: 'is-danger', text: result.error || QUEUE_CSAT_MESSAGES.failed });
      return;
    }
    setCurrent(selected);
    const pending = result.data && result.data.dialplanReloaded === false;
    setMessage({ type: pending ? 'is-warning' : 'is-success', text: pending ? QUEUE_CSAT_MESSAGES.reloadPending : QUEUE_CSAT_MESSAGES.applied });
  };

  return (
    <div className="field mt-4">
      <label className="label" htmlFor={`csat-binding-${queueName}`}>{QUEUE_CSAT_MESSAGES.label}</label>
      <div className="field has-addons">
        <div className="control">
          <div className="select">
            <select id={`csat-binding-${queueName}`} value={selected} onChange={(event) => setSelected(event.target.value)}>
              <option value="">{QUEUE_CSAT_MESSAGES.none}</option>
              {surveys.map((survey) => <option key={survey.id} value={String(survey.id)}>{survey.name}</option>)}
            </select>
          </div>
        </div>
        <div className="control">
          <button type="button" className="button is-info" onClick={apply} disabled={saving || selected === current}>{QUEUE_CSAT_MESSAGES.apply}</button>
        </div>
      </div>
      {message && <p className={`help ${message.type === 'is-danger' ? 'is-danger' : message.type === 'is-warning' ? 'is-warning' : 'is-success'}`}>{message.text}</p>}
    </div>
  );
}

function QueueCsatBinding({ queueName }) {
  if (!queueName || !canManageQueueCsat(hasFeature)) return null;
  return <QueueCsatSelector queueName={queueName} />;
}

export default QueueCsatBinding;
